import { useState } from 'react';

/**
 * Identidad de la casa.
 *
 * Si existe `web/public/logo.png` (el logotipo descargado de
 * salvadorpinarjimenez.com) se usa ese archivo tal cual. Si no, se dibuja el
 * monograma en SVG con los colores de la marca. Sustituir el logotipo es, por
 * tanto, copiar un único archivo: no hay que tocar ni una línea de código.
 */
export function Marca({
  tam = 'm',
  conTexto = true,
  sobreOscuro = false,
}: {
  tam?: 's' | 'm' | 'g';
  conTexto?: boolean;
  sobreOscuro?: boolean;
}) {
  // Orden de preferencia: monograma recortado (fondo transparente, sirve sobre
  // claro y sobre oscuro) → logotipo completo → monograma dibujado en SVG.
  const [fuente, setFuente] = useState<'monograma' | 'logo' | 'svg'>('monograma');
  const sinArchivo = fuente === 'svg';
  const px = tam === 'g' ? 46 : tam === 's' ? 26 : 34;

  return (
    <span className="marca" data-tam={tam}>
      {sinArchivo ? (
        <Monograma px={px} sobreOscuro={sobreOscuro} />
      ) : (
        <img
          className="marca-simbolo"
          src={fuente === 'monograma' ? '/monograma.png' : '/logo.png'}
          alt="Salvador Pinar Jiménez"
          width={px}
          height={px}
          onError={() => setFuente(fuente === 'monograma' ? 'logo' : 'svg')}
        />
      )}
      {conTexto && (
        <span className="marca-texto" style={sobreOscuro ? { color: '#fff' } : undefined}>
          <strong>Salvador Pinar Jiménez</strong>
          <span>Visitas y degustaciones</span>
        </span>
      )}
    </span>
  );
}

/** Monograma de respaldo: dos marcos entrelazados, como en el logotipo. */
function Monograma({ px, sobreOscuro }: { px: number; sobreOscuro: boolean }) {
  return (
    <svg
      className="marca-simbolo"
      width={px}
      height={px}
      viewBox="0 0 48 48"
      role="img"
      aria-label="Salvador Pinar Jiménez"
    >
      <rect x="6" y="6" width="24" height="24" fill="none" stroke="var(--acento)" strokeWidth="5" />
      <rect
        x="18"
        y="18"
        width="24"
        height="24"
        fill="none"
        stroke={sobreOscuro ? 'var(--acento-clara)' : 'var(--acento)'}
        strokeWidth="5"
      />
      <rect
        x="18"
        y="18"
        width="12"
        height="12"
        fill={sobreOscuro ? 'transparent' : 'var(--papel)'}
      />
    </svg>
  );
}
